export const endpoint = {
  signIn: "signIn",
  signUp: "signUp",
  updateProfile: "updateProfile",
  changePassword: "changePassword",
  changePhone: "changePhone",
  changeEmail: "changeEmail",
  customizeWebsite: "customizeWebsite",
  resendOtpChangePhoneEmail: "resendOtpChangePhoneEmail",
  verifyOtpChangePhoneEmail: "verifyOtpChangePhoneEmail",
  forgotPassword: "forgotPassword",
  getCms: "getCms",
  getChecklist: "getChecklist",
  resetPassword: "resetPassword",
  getChecklistEvent: "getChecklistEvent",
  getChecklistCategory: "getChecklistCategory",
  deleteChecklist: "deleteChecklist",
  createChecklist: "createChecklist",
  updateViewStatusChecklist: "updateViewStatusChecklist",
  updateChecklist: "updateChecklist",
  /////////////////////////////////
  verifyOtpSignup: "verifyOtpSignup",
  resendOtp: "resendOtp",
  getProfile: "getProfile",

  getAdminProfile: "/getAdminProfile",

  getAllusers: "/getAllusers",
  getUserDetails: "/getUserDetails",
  deleteUser: "/deleteUser",
  updateStatus: "/updateStatus",
  getEventsCreatedByUser: "/getEventsCreatedByUser",

  getServices: "services",
  /** GET: services grouped with subcategories (e.g. All Services page) */
  servicesWithSubcategories: "services-with-subcategories",

  logout: "logout",

  /** POST { name, email, message } — public contact */
  contactUs: "contactUs",

  /** GET — user notification list */
  getNotificationList: "getNotificationList",
  /** PUT — mark all notifications read (unread_count → 0) */
  markAllNotificationsRead: "markAllNotificationsRead",
  /** GET query notification_id — remove one notification */
  deleteNotification: (notificationId) =>
    `deleteNotification?notification_id=${encodeURIComponent(
      String(notificationId).trim()
    )}`,

  getFaq: "/getFaq",
  updateFaq: "/updateFaq",
  createFaq: "/createFaq",
  deleteFaq: "/deleteFaq",
  getSubCategory: (serviceId) => `/subcategory/${serviceId}`,
  getListing: "/listings",
  createEnquiry: "enquiry",
  getEnquiries: "enquiry",
  getEnquiryById: (enquiryId) =>
    `enquiry/${encodeURIComponent(String(enquiryId).trim())}`,
  updateEnquiryStatus: (inquiryId) => `enquiry/${inquiryId}/status`,
  updateSampleRecord: (sampleRecordId) => `update-sample-record/${sampleRecordId}`,
  getLocations: "/cities",
  getEventTypes: "/event-types",
  booking: "booking",
  /** GET {REACT_APP_API}booking/:id → e.g. /v1/user/booking/:bookingId */
  getBookingDetails: (bookingId) => `booking/${bookingId}`,
  /** PUT body: { customer_review, customer_rating } — user review after booking complete */
  bookingReviewRating: (bookingId) => `booking/${bookingId}/review-rating`,
  /** GET refund preview before cancellation confirm */
  cancelRefundPreview: (bookingId) =>
    `booking/${bookingId}/cancel-refund-preview`,
  /** GET {REACT_APP_API}invoice-detail/:id */
  getInvoiceDetail: (id) => `invoice-detail/${id}`,
  /** POST — service bookings: { booking_id, service_category_id, title, description } */
  createHelpTicket: "createHelpTicket",
  /** POST /v1/user/shop/createHelpTicket — { shop_order_id, title, description } */
  shopCreateHelpTicket: "shop/createHelpTicket",
  /** GET query: booking_id; optional service_type (e.g. SERVICE) scopes ticket for service bookings */
  getTicketByBookingId: (bookingId, serviceType) => {
    const q = `booking_id=${encodeURIComponent(String(bookingId))}`;
    const st =
      serviceType != null && String(serviceType).trim() !== ""
        ? `&service_type=${encodeURIComponent(String(serviceType).trim())}`
        : "";
    return `getTicketByBookingId?${q}${st}`;
  },
  /** GET /v1/user/shop/getTicketByOrderId?shop_order_id= */
  shopGetTicketByOrderId: (shopOrderId) =>
    `shop/getTicketByOrderId?shop_order_id=${encodeURIComponent(String(shopOrderId).trim())}`,
  /** POST body: { ticket_id, message } */
  userReply: "userReply",
  /** PUT body: { ticket_id } — reopen a closed ticket */
  reopenTicket: "reopen",
  /** PUT body: { ticket_id } — user declines further help / close ticket */
  closeTicket: "closeTicket",
  /** PUT body: { cancel_status, cancel_reason } */
  updateBookingStatus: (bookingId) => `booking/${bookingId}/status`,
  updateBookingAmount: (bookingId) => `booking/${bookingId}/amount`,
  getBookingsByService: (serviceId) => `bookings/service?service_id=${serviceId}`,
  /** GET ?page=&limit=&filters… — relative to REACT_APP_API (/v1/user/) */
  getPackages: "packages",
  /** GET — filter definitions + list API paths for package PLP */
  getPackageFilters: "packages/filters",
  getPackageById: (packageId) =>
    `packages/${encodeURIComponent(String(packageId).trim())}`,
  /** POST — send package inquiry (not a confirmed booking) */
  postPackageEnquiry: "packages/enquiry",
  /** GET ?page=&limit=&search= — user's package inquiries */
  getPackageEnquiries: "packages/my-enquiries",
  /** GET — single package enquiry by Mongo id */
  getPackageEnquiryById: (enquiryId) =>
    `packages/enquiry/${encodeURIComponent(String(enquiryId).trim())}`,
  /** GET ?page=&limit=&search= — user's package bookings */
  getPackageBookings: "packages/my-bookings",
  getPackageBookingById: (bookingId) =>
    `packages/my-bookings/${encodeURIComponent(String(bookingId).trim())}`,
  /** POST { package_enquiry_id, payment_type: 1 | 2 | 3 } — convert enquiry to booking */
  packageBooking: "package-booking",
  /** GET — issue categories, resolutions, status labels */
  userDisputeMeta: "dispute/meta",
  /** GET ?booking_id= — line items for create dispute */
  userDisputeBookingContext: "dispute/booking-context",
  /** POST multipart/form-data — create dispute */
  userDisputeCreate: "dispute/create",
  /** GET ?dispute_tab=&page=&limit= */
  userDisputeList: "dispute/list",
  /** GET ?dispute_id= — query keys are flat (not nested under params) */
  userDisputeDetail: "dispute/detail",
  /** POST { dispute_id, message } */
  userDisputeReply: "dispute/reply",
  /** PUT { dispute_id } */
  userDisputeReopen: "dispute/reopen",
  /** PUT { dispute_id } */
  userDisputeClose: "dispute/close",
  getCateringPackageList: "catering/package-management-list",
  getCateringPreset: "catering-preset",
  getCateringCustomPreset: "catering-custom-preset",
  getChooseCustomMenuItems: "user/choose-custom-menu-items",
  getChoosePresetMenuItems: (presetMenuId) => `choose-preset-menu-items/${presetMenuId}`,
  addPresetCart: "add-preset-cart",
  getCartList: "cart-list",
  deleteCartItem: (cartId, type, lineItemId) => `delete-cart-item/${cartId}/${type}/${lineItemId}`,
  getAddressList: "get-address-list",
  addAddress: "add-address",
  updateAddress: (addressId) => `update-address/${addressId}`,
  removeAddress: (addressId) => `remove-address/${addressId}`,
  changeAddress: (addressId) => `change-address/${addressId}`,
  sampleRecord: "sample-record",
  getSampleRecord: "get-sample-record",
  paymentPending: (id) => `payment-pending?id=${id}`,
  samplePaymentPending: (id) => `sample-payment-pending?id=${id}`,
  createOrder: "create-order",
  cateringBooking: "catering-booking",
  installmentSummary: "installment-summery",
  sampleBooking: "sample-create-order",

  /** GET query: service_id, city — optional page, limit; auth required */
  vendorServicesByServiceAndCity: "vendor-services/by-service-and-city",

  /** GET /v1/user/shop/categories — parent → sub → category tree for Shop header */
  shopCategories: "shop/categories",
  /** GET /v1/user/shop/categoriesWithParent — AllShop landing (no parent id required) */
  shopCategoriesWithParent: "shop/categoriesWithParent",
  /** GET /v1/user/homepage/sections — landing page shop/rent scrollers */
  homepageSections: "homepage/sections",
  /**
   * POST /v1/user/delivery-serviceability
   * { delivery_pincode, cod, payment_method, items: [{ product_id, product_type, quantity }] }
   */
  deliveryServiceability: "delivery-serviceability",
  /** GET /v1/user/rent/categories — parent → sub → sub-sub tree for Rent header */
  rentCategories: "rent/categories",
  /**
   * GET /v1/user/shop/productMasters
   * Query: parent_category_id, sub_category_id, category_id
   */
  shopProductMasters: "shop/productMasters",
  /**
   * POST /v1/user/shop/productList — shop products + master filters
   * GET  /v1/user/shop/productList?_id= — product detail
   */
  shopProductList: "shop/productList",
  /** GET /v1/user/shop/product/:id?quantity=&size_id=&color_id= */
  shopProduct: (productId) =>
    `shop/product/${encodeURIComponent(String(productId).trim())}`,
  /** GET /v1/user/shop/product/:productId/reviews?page=&limit=&sort= */
  shopProductReviews: (productId) =>
    `shop/product/${encodeURIComponent(String(productId).trim())}/reviews`,
  /**
   * GET /v1/user/rent/productMasters
   * Query: parent_category_id, sub_category_id, category_id
   */
  rentProductMasters: "rent/productMasters",
  /**
   * POST /v1/user/rent/productList — rent products + master filters
   * GET  /v1/user/rent/productList?_id= — rent product detail
   */
  rentProductList: "rent/productList",

  /** POST body: { product_id, product_type: "shop" | "rent" } */
  wishlistToggle: "wishlist/toggle",
  /**
   * GET query:
   *  product_id + product_type — whether that product is favourited
   *  product_type + page + limit — paginated wishlist
   */
  wishlist: "wishlist",

  /** POST { product_id, size_id, color_id, quantity } */
  shopCartAdd: "shop/cart/add",
  /** GET shop cart */
  shopCart: "shop/cart",
  /** PUT { quantity, is_selected } | DELETE */
  shopCartItem: (itemId) => `shop/cart/item/${encodeURIComponent(String(itemId).trim())}`,

  /** POST { item_ids: [] } — start checkout from selected cart items */
  shopCheckoutStart: "shop/checkout/start",
  /** POST { product_id, quantity, size_id, color_id } */
  shopBuyNow: "shop/buy-now",
  /** PUT { address_id } */
  shopCheckoutAddress: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/address`,
  /** GET available coupons for a checkout session */
  shopCheckoutCoupons: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/coupons`,
  /** POST { code } — apply coupon to a checkout session */
  shopCheckoutCoupon: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/coupon`,
  /** POST { code } — preview coupon against the session */
  shopCheckoutCouponPreview: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/coupon/preview`,
  /** GET order summary for a checkout session */
  shopCheckoutSummary: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/summary`,
  /** POST — place order / confirm checkout session */
  shopCheckoutConfirm: (sessionId) =>
    `shop/checkout/${encodeURIComponent(String(sessionId).trim())}/confirm`,
  /** POST Razorpay verify payload after shop payment */
  shopVerifyPayment: "shop/verify-payment",
  /** GET /v1/user/shop/orders?page=&limit=&status_group=&search= */
  shopOrders: "shop/orders",
  /** GET /v1/user/shop/orders/:shopOrderId */
  shopOrder: (shopOrderId) =>
    `shop/orders/${encodeURIComponent(String(shopOrderId).trim())}`,
  /** GET /v1/user/shop/return-reasons — dropdown options for order return */
  shopReturnReasons: "shop/return-reasons",
  /** POST /v1/user/shop/orders/:shopOrderId/return-request */
  shopOrderReturnRequest: (shopOrderId) =>
    `shop/orders/${encodeURIComponent(String(shopOrderId).trim())}/return-request`,
  /** POST /v1/user/shop/orders/:shopOrderId/cancel — body: { reason_note } */
  shopOrderCancel: (shopOrderId) =>
    `shop/orders/${encodeURIComponent(String(shopOrderId).trim())}/cancel`,
  /** GET /v1/user/shop/orders/:shopOrderId/invoice */
  shopOrderInvoice: (shopOrderId) =>
    `shop/orders/${encodeURIComponent(String(shopOrderId).trim())}/invoice`,
  /** POST /v1/user/shop/orders/:shopOrderId/review — { product_id, rating, review } */
  shopOrderReview: (shopOrderId) =>
    `shop/orders/${encodeURIComponent(String(shopOrderId).trim())}/review`,

  /**
   * POST { product_id, quantity, event_date, rental_start_date, rental_duration, size_id, color_id }
   */
  rentCartAdd: "rent/cart/add",
  /** GET rent cart */
  rentCart: "rent/cart",
  /** PUT { quantity, is_selected } | DELETE */
  rentCartItem: (itemId) => `rent/cart/item/${encodeURIComponent(String(itemId).trim())}`,
};
